import React from "react";
import ProductHead$ from "@deosite/components-new/ProductHead";
import OptionsSelector from "../OptionsSelector";
import Button from "@deosite/components-new/buttons/Button";
import {
  ButtonArrowRight,
  ButtonArrowLeft
} from "@deosite/components-new/buttons/ButtonArrow";
import QuantityPicker from "../quantityPickers/QuantityPicker";
import AddToCartIcon from "../../icons/cart_for_button.svg";
import HeartIcon from "../../icons/heart.svg";
import HeartOutlineIcon from "../../icons/heart-light.svg";

const ProductHead = props => {
  const propsExt = {
    ...props,
    optionsSelector: <OptionsSelector />,
    button: <Button leftIcon={<AddToCartIcon />} />,
    buttonArrowLeft: <ButtonArrowLeft />,
    buttonArrowRight: <ButtonArrowRight />,
    quantityPicker: <QuantityPicker />,
    showProducerAndCollectionInfo: true,
    showDescriptionAsAccordion: false,
    showAdditionalFeeInfo: true,
    wishlistIcon: <HeartIcon />,
    wishlistOutlineIcon: <HeartOutlineIcon />
  };
  return <ProductHead$ {...propsExt} />;
};

export default ProductHead;
